import {useCallback, useState} from "react";

export default function useTransientMessage() {
    const [notice, setNotice] = useState({message: "", messageKey: 0});
    // Two successful actions can have identical text; each still gets its own display lifetime.
    const showMessage = useCallback(message => setNotice(previous => ({message, messageKey: previous.messageKey + 1})), []);
    const dismiss = useCallback(() => setNotice(previous => previous.message ? {...previous, message: ""} : previous), []);
    return {...notice, showMessage, dismiss};
}
